import {SC_BasicNote} from "./SC_BasicNote";
import {formatNoteDate} from "../../DateUtils";
import DOMPurify from 'dompurify';

// @ts-ignore
export class SC_FMNote extends SC_BasicNote {
    static inputKeys = {
        subject: 'subject',
        body: 'body',
        externalAuthor: 'externalAuthor'
    } as const;

    public subject: string | null;
    public body: string | null;
    public externalAuthor: string | null;

    constructor({
        subject = null,
        body = null,
        externalAuthor = null,
        props
    } = {}) {
        super(props);

        this.subject = subject;
        this.body = body;
        this.externalAuthor = externalAuthor;
    }

    static fromApi(jsonin: Record<string, any>): SC_FMNote {
        return new SC_FMNote({
            subject: jsonin[this.inputKeys.subject] ?? null,
            body: jsonin[this.inputKeys.body] ?? null,
            externalAuthor: jsonin[this.inputKeys.externalAuthor] ?? null,
            props: super.basicAPIStuff(jsonin),
        })
    }

    toAPI(): Record<string, unknown> {
        return {
            [SC_FMNote.inputKeys.subject]: this.subject,
            [SC_FMNote.inputKeys.body]: this.body,
            [SC_FMNote.inputKeys.externalAuthor]: this.externalAuthor,
        };
    }

    noteItem(someFup: boolean, requestResolution: (note: SC_BasicNote) => void) {
        return <NoteItem note={this} showFollowUp={someFup} requestResolution={requestResolution}/>;
    }

    get displayText() {
        return DOMPurify.sanitize(this.body, {USE_PROFILES: {HTML: false}});
    }

    get displayHTML() {
        return DOMPurify.sanitize(this.body, { ALLOWED_ATTR: [] });
    }
}

const NoteItem = ({note, showFollowUp, requestResolution}: {note: SC_FMNote, showFollowUp: boolean, requestResolution: (note: SC_BasicNote) => void}) => {
    let user: string | JSX.Element;

    if (note.internalAuthor?.name)
        user = note.internalAuthor.name;
    else if (note.internalAuthor)
        user = "Someone at SiteCrew";
    else if (note.externalAuthor)
        if (note.externalAuthor === "OnDemandAutomation")
            user = <i>FM System</i>;
        else if (note.externalAuthor === "VendorAPI")
            user = <i>Insite</i>;
        else
            user = note.externalAuthor;
    else
        user = "Unknown";

    return <tr>
        <td style={{textAlign: "center"}}><a style={{display: "contents", cursor: "help"}} title={"Fm Pilot Note"}><img src={"/wp-content/themes/developmenttheme/assets/images/fmpilot.ico"} alt={"FM Pilot Logo"} style={{height: "1rem"}}/></a></td>
        <td style={{textWrap: "nowrap"}}>{formatNoteDate(note.noteCreatedTime)}</td>
        <td>{user}</td>
        {showFollowUp ? <td></td> : null}
        <td>
            {!(note.subject?.match(/^WO: (PM|WEB)-\d+$/i)) ? <span>{note.subject}:<br/></span> : null}
            {<span dangerouslySetInnerHTML={{__html: note.displayHTML}} />}
        </td>
    </tr>;
}
